jQuery(document).ready(function($){
  $('.img_popup').magnificPopup({
      type: 'image'
  });
  
  $('.pdf_popup').magnificPopup({
      type: 'iframe'
  });

  $(document).on('click', '[data-item]', function(event){
    event.preventDefault();
    var item = $(this).data('item');

    $('[data-modal-item="'+ item +'"]').addClass('open');
  });

  
  $(document).on('click', '[data-modal-item]', function(event){
    event.preventDefault();
    var item = $(this).data('item');

    $('[data-modal-item]').removeClass('open');
  })
});